<template>
  <div class="about-duty">
    <div class="bg"></div>
    <div class="container">
      <div class="about-subject">
        <div class="about-title"><span>健康责任</span> </div>
        <div class="about-describe">懒精灵守护神的第一责任——健康安全</div>
        <div class="about-elemnet">
          <div>
            <p>0j甲醛</p>
          </div>
          <div>
            <p>0释放</p>
          </div>
          <div>
            <p>强吸附</p>
          </div>
          <div>
            <p>高分解</p>
          </div>
        </div>
      </div>
      <div class="about-content">
        <div class="block">
          <h3 class="small">
            <h4 class="h-color">法国室内环境检测A+级认证</h4>
            <p>"A+"是法国VOC标签“Émissions dans l’air intérieur”(室内空气排放标准)中环保等级最高的标志，也是欧洲环保等级最高的标志。</p>
            <div class="img-box">
              <img src="@/assets/images/about/banner1.png" alt="">
            </div>
          </h3>
        </div>
        <div class="border"></div>
        <div class="block">
          <h3 class="small">
            <h4 class="h-color">国家涂料产品质量监督检测合格</h4>
            <p>VOC含量、甲醛含量、苯系物总和含量【限苯、甲苯、二甲苯（含乙苯）】、总铅（Pb）hanliang (限色漆和腻子)、可溶性重金属含量（限色漆和腻子），检测判
              定本次委托检验共检5项，所检项目全部符合标准的要求。</p>
            <div class="img-box">
              <img src="@/assets/images/about/banner2.png" alt="">
            </div>
          </h3>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
@height: 750px;
.about-duty {
  min-height: @height;
  overflow: hidden;
  position: relative;
  background: #f8f8f8;
  position: relative;
  .bg {
    position: absolute;
    background: url(https://img.xnxx.mengcreate.com/LJL/about3.png);
    background-size: cover;
    width: 100%;
    height: 307px;
  }
  .container {
    position: relative;
    height: @height;
    .about-subject {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 307px;
      .about-title {
        span {
          display: inline-block;
          font-weight: 500;
          padding: 0.2rem;
          border-bottom: 1px #007455 solid;
          margin-bottom: 3rem;
          color: #007455;
        }
      }
      .about-describe {
        padding-left: 1rem;
        font-size: 2rem;
        font-weight: 500;
        line-height: 3rem;
        color: #007455;
        max-width: 380px;
        margin-bottom: 2rem;
        margin-left: 2rem;
      }
      .about-elemnet {
        display: flex;
        margin-left: 2rem;
        div {
          width: 60px;
          height: 60px;
          border: 1px solid #fff;
          border-radius: 50% 50%;
          align-content: center;
          margin-right: 0.5rem;
          p {
            text-align: center;
            line-height: 0;
            margin: 30px auto;
            color: #007455;
          }
        }
      }
    }
    .about-content {
      display: flex;
      background: #fff;
      height: 403px;
      margin-bottom: 3rem;
      padding: 1.5rem 0;
      .block {
        padding: 0 1.5rem;
        height: 100% !important;
        width: 50%;
        .h-color {
          color: #007455;
          line-height: 0;
        }
        p {
          margin-top: 0;
          line-height: 26px;
          font-size: 12px;
          font-weight: 400;
        }
        .img-box {
          flex: 1;
          width: 80%;
          height: 100%;
          margin: 0 auto;
          // background: #007455;
          text-align: center;
          img {
            width: 100%;
            height: 200px;
          }
        }
      }
    }
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  //  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  //  background-color: #d3dce6;
}
.border {
  width: 2px;
  background: #cccccc;
  box-sizing: content-box;
  height: 100%;
}
@media only screen and (max-width: 786px) {
  .about-duty {
    height: 130vh;
    .container {
      max-width: 786px;
      width: 100%;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      height: 130vh;
      .about-content {
        flex: 1;
        flex-direction: column;
        height: 100%;
        margin-bottom: 1rem;
        .block {
          width: 100%;
          .el-carousel {
          }
        }
        .border {
          width: 100%;
          height: 2px;
          margin: 20px 0;
        }
      }
    }
  }
}
</style>